import { atom } from 'jotai';

export interface Rule {
  display: string;
  field: string;
  key: string | null;
  op: string;
  originalField: string;
  value: string;
}
export interface DrilldownItem {
  name: string;
  rule: Rule[][];
}
export const drillDownListAtom = atom<DrilldownItem[]>([]);

export const list4BreadcrumbAtom = atom((get) => {
  return [...get(drillDownListAtom)];
});

export const drillDownFiltersAtom = atom((get) => {
  const drilldownList = get(drillDownListAtom);
  return drilldownList.reduce<Rule[][]>((sum, it) => {
    const { rule = [] } = it;
    return [...sum, ...rule];
  }, []);
});

export const traceIdInfoAtom = atom({
  open: false,
  info: {},
});
